/**
  Receives full log-entry line: "8:15 wake up #tag", strips out time and tags
*/
export function commentFormatter(comment: string): string {
  if (comment == null) {
    return "";
  }

  comment = comment.replace(window.regExes.time, "");
  comment = comment.replace(window.regExes.tag, "");

  // converts json objects
  // regex match for any json object
  // save that as a var
  // put that var into the habits for that day
  //
  // if the regex matches, call a function that handles the json and adding it into habits
  // how does it know where to put it, it needs the date.

  return comment.replace(window.regExes.spaces, " ");
}
